export default {
    fetchPreviouslyViewedInventory: 'same-origin',
    fetchDrDeals: 'omit',
};
